
const LegacyInteroperability = {
  "name": "LegacyInteroperability",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "legacyResourceId": "UnsignedInt64"
  },
  "possibleTypes": ["Customer", "DraftOrder", "Fulfillment", "InventoryItem", "Location", "MarketingEvent", "Metafield", "MetafieldStorefrontVisibility", "Order", "PriceRule", "Product", "ProductVariant", "Refund", "SavedSearch", "ScriptTag", "ShopifyPaymentsDispute", "ShopifyPaymentsPayout", "WebhookSubscription"]
};
export default LegacyInteroperability;